import { combineReducers } from 'redux';

import { reducer as auth } from './modules/auth';
import { reducer as products } from './modules/products';
import { reducer as admin } from './modules/admin';
import { reducer as users } from './modules/users';
import { reducer as agents } from './modules/agents';
import { reducer as uploadedOrders } from './modules/uploadedOrders';
import { reducer as payments } from './modules/payments';
import { reducer as orders } from './modules/orders';
import { reducer as delivery } from './modules/delivery';
import { reducer as notifications } from './modules/notifications';
import { reducer as banners } from './modules/banners';
import { reducer as productSearch } from './modules/productSearch';
import { reducer as appUsers } from './modules/appUsers';
import { reducer as offers} from './modules/offers'
import { reducer as broadCast} from './modules/broadCast'
import {reducer as leads} from './modules/leads'

/* ------------- Assemble Reducers object ------------- */
export default combineReducers({
    auth,
    products,
    admin,
    users,
    agents,
    uploadedOrders,
    payments,
    orders,
    delivery,
    notifications,
    banners,
    productSearch,
    appUsers,
    offers,
    broadCast,
    leads
    
});